import React from "react";
import { Link } from "react-router-dom";
import icons from "../constants/icons.ts";

const FeatureCard = ({ icon, title, description, image, link = "#", cta }) => {
  return (
    <Link to={link} className="block">
      <div className="card hover:shadow-lg transition-shadow duration-300 h-full flex flex-col">
        {/* Image or Icon */}
        <div className="w-full h-48 bg-gradient-to-br from-primary to-secondary flex items-center justify-center overflow-hidden rounded-t-card">
          {image ? (
            <img
              src={image}
              alt={title}
              className="w-full h-full object-cover"
            />
          ) : (
            <i className={`${icon} text-4xl text-white`}></i>
          )}
        </div>

        {/* Content */}
        <div className="flex-1 flex flex-col p-4">
          <h3 className="font-rubik font-bold text-lg text-secondary mb-2">
            {title}
          </h3>
          <p className="font-rubik font-light text-sm text-gray-600 mb-4 flex-1">
            {description}
          </p>
          {cta && (
            <div className="text-primary font-rubik font-medium flex items-center gap-2 hover:gap-3 transition-all">
              {cta}
              <i className={`${icons.actions.arrowRight} text-sm`}></i>
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};

export default FeatureCard;
